import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const CalloutClassName = `${CLASS_NAME_PREFIX}-callout`;
export const CalloutIconContainerClassName = `${CalloutClassName}__icon-container`;
export const CalloutChildrenClassName = `${CalloutClassName}__children`;
export const CalloutChildrenChildClassName = `${CalloutClassName}__children-child`;
export const CalloutChildrenLinkClassName = `${CalloutClassName}__children-link`;
export const CalloutCloseClassName = `${CalloutClassName}__close`;
